import React, { useState, useEffect } from 'react'
import axiosInstance, { wpAxios } from '../../config/axiosResolver'
import axios from 'axios'
import { pickBy, get, find } from 'lodash'
import { isAdmin } from '../../utils'
import { defaultSectionData } from '../single-submission/components/AdditionalInfo/constants'

import SubmissionsDashboard from './submissions-dashboard'

const SubmissionsDashboardContainer = (props) => {
  const { user } = props
  const [submissions, setSubmissions] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [filters, setFilters] = useState({ordering: '-id', submit_email: props.match.params.email, page: page, status: props.location.search ? 'collection' : '' })
  const [notFilters, setNotFilters] = useState({ status: 'collection' })
  const [totalSubmissions, setTotalSubmissions] = useState(0)
  const [vendorUser, setVendorUser] = useState({})
  const isLbb = get(vendorUser, 'is_active', '0') !== '0'
  const isProfile = get(vendorUser, 'vendor_profile.is_active', '0') !== '0'
  const quickSubmissions = get(vendorUser, 'quick_submissions', 0)
  const canQuickSubmit = (isLbb || isProfile) && quickSubmissions > 0
  const totalQuickSubmissions = get(vendorUser, 'quick_submissions', 0)

  if (!isAdmin(user) && props.match.params.email !== user.email) props.history.push(`/submissions/dashboard/${user.email}`)

  useEffect(() => {
    const fetchData = () => {	
      const query = Object.keys(pickBy(filters)).map(key => key + '=' + filters[key]).join('&');
      const notQuery = Object.keys(pickBy(notFilters)).map(key => `${key}!=${notFilters[key]}`).join('&');
      axiosInstance
        .get(`/submissions/?${query}&${notQuery}`)
        .then((result) => {
          setSubmissions(result.data.results)
          setIsLoading(false)
          setTotalSubmissions(result.data.count)
          axios
            .get(`https://www.stylemepretty.com/api/v2/vendor/user/${props.match.params.email}`)
            .then((res) => {
              setVendorUser(res.data.data)
            })
        })
    }

    fetchData()
  }, [filters, notFilters, props.match.params.email])

  const createSubmission = async (data) => {
    const result = await axiosInstance.post(`/submissions/`, {
      title: data.title,
      type: data.type,
      status: data.status
    })
    const id = result.data.id
    const defaultData = find(defaultSectionData, ['type', get(data, 'type')])

    const promises = []
    if (!isAdmin(user) && id > 358705 && defaultData) {
      promises.push(
        wpAxios.post(`https://www.stylemepretty.com/api/v2/submissions/${id}/save-additional-info`, {
          data: {
            type: 'default',
            leadImage: null,
            sections: get(defaultData, 'sections', []),
            title: get(defaultData, 'title', ''),
            subtitle: get(defaultData, 'subtitle', '')
          }
        })
      )
    }
    if (data.workshopHost) {
      promises.push(
        wpAxios.post(`https://www.stylemepretty.com/api/v2/submissions/${id}/set-workshop-data`, { host: data.workshopHost })
      )
    }

    await Promise.all(promises)
    props.history.push(`/submissions/submission/${id}`)
  }

  const createQuickSubmission = async (data) => {
    const result = await axiosInstance.post(`/submissions/`, {
      title: data.title,
      type: data.type,
      description: `${data.gallery}${data.password ? ': ' + data.password : ''}`,
      status: 'quick'
    })
    const id = result.data.id
    const defaultData = find(defaultSectionData, ['type', get(data, 'type')])

    const promises = []
    if (id > 358705 && defaultData) {
      promises.push(
        wpAxios.post(`https://www.stylemepretty.com/api/v2/submissions/${id}/save-additional-info`, {
          data: {
            type: 'default',
            leadImage: null,
            sections: get(defaultData, 'sections', []),
            title: get(defaultData, 'title', ''),
            subtitle: get(defaultData, 'subtitle', '')
          }
        })
      )
    }
    if (data.workshopHost) {
      promises.push(
        wpAxios.post(`https://www.stylemepretty.com/api/v2/submissions/${id}/set-workshop-data`, { host: data.workshopHost })
      )
    }
    promises.push(
      wpAxios.post(`https://www.stylemepretty.com/api/v2/submissions/quick/decrement`, { id: get(vendorUser, 'id') }),
      wpAxios.post(`https://www.stylemepretty.com/api/v2/submissions/set-quick`, { id: id })
    )

    await Promise.all(promises)
    props.history.push(`/submissions/submission/${id}`)
  }

  return (
    <SubmissionsDashboard
      submissions={submissions}
      isLoading={isLoading}
      page={page}
      setPage={setPage}
      user={user}
      setFilters={setFilters}
      setNotFilters={setNotFilters}
      filters={filters}
      notFilters={notFilters}
      totalSubmissions={totalSubmissions}
      createSubmission={createSubmission}
      createQuickSubmission={createQuickSubmission}
      vendorUser={vendorUser}
      history={props.history}
      canQuickSubmit={canQuickSubmit}
      totalQuickSubmissions={totalQuickSubmissions}
    />
  )
}

export default SubmissionsDashboardContainer

